<section class="mt-3" *ngIf="data && data.length && show">
  <mat-expansion-panel>

    <mat-expansion-panel-header>
      <mat-panel-title class="mt-2">
        <div class="h6 text-nowrap" i18n>Podpora</div>
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div *ngFor="let d of data" class="mb-3">
        <a title="{{d.nazov}}" target="_self" [href]="getDiskusiaUrl(d)">
            <b>{{d.nazov}} ({{d.pocet}})</b>
        </a>
        <div>{{d.popis}}</div>
    </div>

    <hr/>
    <div class="d-flex flex-row align-items-center">
    </div>
  </mat-expansion-panel>
</section>
